import Alpine from 'alpinejs';

Alpine.store('reservations', {
    isFetched: false,
    isLoading: false,
    upcoming: [],
    past: [],
    error: null,

    async init() {
        // Wait for user store to be fetched, then fetch reservations if logged in
        // This handles the async race condition
        const checkAndFetch = async () => {
            const userStore = Alpine.store('user');
            if (userStore && userStore.isFetched) {
                if (userStore.isLoggedIn && !this.isFetched && !this.isLoading) {
                    await this.fetchReservations();
                }
            }
        };

        // Check immediately in case user store already loaded
        await checkAndFetch();

        // Also set up an interval to check (Alpine stores don't have reactive watchers)
        // This will be cleaned up after first successful fetch
        const intervalId = setInterval(async () => {
            const userStore = Alpine.store('user');
            if (userStore && userStore.isFetched) {
                clearInterval(intervalId);
                if (userStore.isLoggedIn && !this.isFetched && !this.isLoading) {
                    await this.fetchReservations();
                }
            }
        }, 100);

        // Clear interval after 5 seconds max to prevent memory leaks
        setTimeout(() => clearInterval(intervalId), 5000);
    },

    async fetchReservations() {
        if (this.isLoading) return;
        
        this.isLoading = true;
        this.error = null;

        try {
            console.log('Fetching reservations from API...');
            const response = await fetch('/actions/avari/account/reservations', {
                credentials: 'include'
            });

            console.log('Reservations API response status:', response.status);

            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }

            const data = await response.json();
            console.log('Reservations API response data:', data);

            if (data.success) {
                this.upcoming = data.upcoming || [];
                this.past = data.past || [];
                this.isFetched = true;
                console.log('Reservations loaded:', {
                    upcoming: this.upcoming.length,
                    past: this.past.length
                });
            } else {
                throw new Error('Failed to fetch reservations');
            }
        } catch (error) {
            console.error('Error fetching reservations:', error);
            this.error = error.message;
            this.isFetched = true; // Mark as fetched even on error to show error state
        } finally {
            this.isLoading = false;
        }
    },

    parseDateOnly(value) {
        if (typeof value !== 'string') return null;
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return null;

        const year = Number(match[1]);
        const month = Number(match[2]) - 1;
        const day = Number(match[3]);
        return new Date(year, month, day);
    },

    // Format date for display (e.g., "Jan 26 - 29, 2026")
    formatDateRange(checkIn, checkOut) {
        if (!checkIn || !checkOut) return '';

        const options = { month: 'short', day: 'numeric' };
        const yearOptions = { year: 'numeric' };

        const startDate = this.parseDateOnly(checkIn);
        const endDate = this.parseDateOnly(checkOut);
        if (!startDate || !endDate) return '';
        
        const startStr = startDate.toLocaleDateString('en-US', options);
        const endDay = endDate.getDate();
        const endYear = endDate.toLocaleDateString('en-US', yearOptions);
        
        // If same month, show: "Jan 26 - 29, 2026"
        // If different months, show: "Jan 26 - Feb 2, 2026"
        if (startDate.getMonth() === endDate.getMonth()) {
            return `${startStr} - ${endDay}, ${endYear}`;
        } else {
            const endStr = endDate.toLocaleDateString('en-US', options);
            return `${startStr} - ${endStr}, ${endYear}`;
        }
    }
});
